import React, { PureComponent } from 'react';
import { scaleLinear as d3ScaleLinear } from 'd3-scale';

import Bar from './bar';


class Bars extends PureComponent {
  getBars() {
    const scaleX = d3ScaleLinear()
      .range([0, this.props.width])
      .domain(this.props.domain);

    return this.props.data.values.map((val, i) => {
      const barX = this.props.type === 'left' ? this.props.width - scaleX(val.value) : 0;

      return (<Bar
        key={`${this.props.type}__${val.key}`}
        x={barX}
        y={this.props.scaleY(val.key)}
        width={scaleX(val.value)}
        height={this.props.scaleY.bandwidth()}
        fill={this.props.highlightIndex === i ? '#CA9C4D' : '#2e4964'}
        data={`${val.key}--${val.value}`}
      />);
    });
  }

  render() {
    return this.getBars();
  }
}

export default Bars;




// WEBPACK FOOTER //
// ./src/components/BarChart/bars.js